import { useEffect, useState } from "react";
import {
  Button,
  Collapse, Form, Input, Select,
  Switch, Typography
} from "antd";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { cardPolicies, cardSetPolicies } from "../../../../actions/cards/cards";
import { MinusCircleOutlined } from "@ant-design/icons";
import * as yup from 'yup'
const { Panel } = Collapse;
//  import { validationRules } from '../../../utils';
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;


const ValidationSchema = yup.object().shape({
  policy_name: yup.string().required("Policy name is required."),
  policy_description: yup.string(""),
  card_limit: yup.array().of(yup.object().shape({
    transaction_type: yup.string().required(),
    amount: yup.string().required(),
    frequency: yup.string().required(),
  }))
})

const AddCards = (props) => {
  const dispatch = useDispatch();
  const { from } = props;
  const cardPoliciesRes = useSelector((state) => state?.cards?.cardPolicies);
  const [chan_key, set_chan_key] = useState("users");
  const initialValues = {
    policy_name: "",
    policy_description: "",
    channel_enabled: [
      {
        POS: false,
      },
      {
        ATM: false,
      },
      {
        ECOM: false,
      },
      {
        CTLS: false,
      }
    ],
    card_limit: [
      {
        transaction_type: "",
        amount: "",
        frequency: "",
      },
    ],
  }
  const formik = useFormik({
    initialValues,
    validationSchema: ValidationSchema,
    onSubmit: (vals) => {
      let obj = JSON.parse(JSON.stringify({ ...vals }))
      if (vals[chan_key])
        obj.data = {
          [chan_key]: vals[chan_key]
        }
      if (obj[chan_key])
        delete obj[chan_key]

      if (props.selectedRow?.id) {
        obj.edit = true
        obj.card_policy_id = props.selectedRow?.id
        delete obj.card_policy_limit
        delete obj.file_status_url
        delete obj.id
        delete obj.status
        delete obj.assigned_data
        delete obj.name
      }
      dispatch(cardSetPolicies({ card: obj }));
    },
  });

  useEffect(() => {
    dispatch(cardPolicies());
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (props.selectedRow && props.selectedRow?.id) {
      let obj = {
        ...props.selectedRow,
        card_limit: from === "card_detail" ? props.selectedRow?.card_limit : props.selectedRow?.card_policy_limit ? props.selectedRow?.card_policy_limit : [],
        channel_enabled: from === "card_detail" ? props?.selectedRow?.channel_enabled : props?.selectedRow?.channel_data
      }
      if (props.selectedRow.assigned_data) {
        let chan_key1 = Object.keys(props.selectedRow.assigned_data)?.[0];
        if (chan_key1) {
          set_chan_key(chan_key1)
          obj[chan_key1] = props.selectedRow?.assigned_data?.[chan_key1]
        }
      }
      formik.setValues(obj)
    } else {
      formik.resetForm()
    }
    // eslint-disable-next-line
  }, [props.selectedRow])

  const handleCancelButton = () => {
    // form.resetFields();
    formik.setValues({

    })
    props.handleCancel();
  };

  return (
    <>
      <Form
        layout="vertical"
        // form={form}
        onFinish={formik.handleSubmit}
        className="modal-form"
      >
        <Form.Item label="Policy Name"
          help={formik.touched.policy_name && formik.errors.policy_name}
          required={true}
          validateStatus={formik.errors.policy_name && formik.touched.policy_name ? "error" : "success"}
        >
          <Input
            placeholder="Default Policy"
            onChange={formik.handleChange}
            name="policy_name"
            value={formik.values.policy_name}
          />
        </Form.Item>
        <Form.Item label="Description">
          <TextArea
            placeholder="Enter Description (Optional)"
            autoSize={{ minRows: 3, maxRows: 5 }}
            onChange={formik.handleChange}
            name="policy_description"
            value={formik.values.policy_description}
            help={formik.touched.policy_description && formik.errors.policy_description}
            validateStatus={formik.errors.policy_description && formik.touched.policy_description ? "error" : "success"}
          />
        </Form.Item>
        <div className="dividerText">Define Conditions for this policy</div>
        <Form.Item name="checkboxGroup" style={{ marginBottom: "5px" }}>
          <Collapse
            accordion
            className="customCollapse"
            defaultActiveKey={["1"]}
          >
            <Panel header={<b>Define the Users ( if any )</b>} key="1">
              <Text>Choose who will be affected by this rule.</Text>
              <div className="viewPolicyCards">
                1<div className="darkbox">Rule will apply to</div>
                <div className="lightbox">
                  <Select
                    placeholder="Select "
                    onChange={(val) => {
                      set_chan_key(val)
                    }}
                    value={chan_key}
                  >
                    <Option value="users">Specific user</Option>
                    <Option value="grade_designation">
                      Specific Grade/Designation
                    </Option>
                    <Option value="cost_centers">Cost Center</Option>
                    <Option value="projects">Project</Option>
                  </Select>
                </div>
                <div className="lightbox">
                  <Select
                    placeholder="Select "
                    onChange={(val) => {
                      formik.setFieldValue(chan_key, [val]);
                      Array.from(["users", "grade_designation", "cost_centers", "projects"]).forEach(ele => {
                        if (chan_key !== ele)
                          formik.setFieldValue(ele, undefined)
                      })
                    }}
                    showSearch
                    filterOption={(input, option) => {
                      return (option?.children?.toLowerCase())?.includes(input?.toLowerCase())
                    }}
                    value={formik.values?.[chan_key]?.[0]}
                  >
                    {cardPoliciesRes?.data?.response?.[chan_key]?.map((ele) => (
                      <Option value={ele.id} key={ele.id}>{ele.title || ele.name}</Option>
                    ))}
                  </Select>
                </div>
              </div>
            </Panel>
          </Collapse>
        </Form.Item>
        <Form.Item name="checkboxGroup" style={{ marginBottom: "5px" }}>
          <Collapse
            accordion
            className="customCollapse"
            defaultActiveKey={["2"]}
          >
            <Panel header={<b>Card Usage Controls</b>} key="2">
              <div className="card-usage">
                <div className="item">
                  <div>
                    <span>POS</span>
                    <span></span>
                  </div>
                  <Switch
                    className="switch"
                    onChange={(e) => {
                      let channels = formik.values.channel_enabled;
                      channels[0].POS = e;
                      formik.setFieldValue("channel_enabled", channels);
                    }}
                    checked={formik.values?.channel_enabled?.[0]?.POS}
                  />
                </div>
                <div className="item">
                  <div>
                    <span>ATM Withdrawal</span>
                    <span></span>
                  </div>
                  <Switch
                    className="switch"
                    onChange={(e) => {
                      let channels = formik.values.channel_enabled;
                      channels[1].ATM = e;
                      formik.setFieldValue("channel_enabled", channels);
                    }}
                    checked={formik.values?.channel_enabled?.[1]?.ATM}
                  />
                </div>
                <div className="item">
                  <div>
                    <span>Online Transactions</span>
                    <span></span>
                  </div>
                  <Switch
                    className="switch"
                    onChange={(e) => {
                      let channels = formik.values.channel_enabled;
                      channels[2].ECOM = e;
                      formik.setFieldValue("channel_enabled", channels);
                    }}
                    checked={formik.values?.channel_enabled?.[2]?.ECOM}
                  />
                </div>
                <div className="item">
                  <div>
                    <span>Contact Less</span>
                    <span></span>
                  </div>
                  <Switch
                    className="switch"
                    onChange={(e) => {
                      let channels = formik.values.channel_enabled;
                      channels[3].CTLS = e;
                      formik.setFieldValue("channel_enabled", channels);
                    }}
                    checked={formik.values?.channel_enabled?.[3]?.CTLS}
                  />
                </div>
              </div>
            </Panel>
          </Collapse>
        </Form.Item>
        <Collapse accordion className="customCollapse" defaultActiveKey={["3"]}>
          <Panel header={<b>Define the limit ( if any )</b>} key="3">
            <Text>Create limits for this rule.</Text>
            {formik.values.card_limit.map((ele, i) => (
              <>
                <div className="viewPolicyCards">
                  {i + 1}
                  <div className="darkbox">When</div>
                  <Select
                    placeholder="Select "
                    onChange={(val) =>
                      formik.setFieldValue(`card_limit[${i}].frequency`, val)
                    }
                    value={formik.values.card_limit[i].frequency}
                  >
                    <Option value="DAILY">Daily Limit</Option>
                    <Option value="MONTHLY">Monthly Limit</Option>
                    <Option value="ANNUALLY">Yearly Limit</Option>
                  </Select>
                  <div className="darkbox">For</div>
                  <Select
                    placeholder="Select "
                    onChange={(val) =>
                      formik.setFieldValue(
                        `card_limit[${i}].transaction_type`,
                        val
                      )
                    }
                    value={formik.values.card_limit[i].transaction_type}
                  >
                    <Option value="ATM">ATM</Option>
                    <Option value="POS">POS</Option>
                    <Option value="ECOM">Online</Option>
                    <Option value="CTLS">ContactLess</Option>
                  </Select>
                </div>
                <div className="viewPolicyCards">
                  Amount
                  <Input
                    name="amount"
                    onChange={(e) => {
                      formik.setFieldValue(
                        `card_limit[${i}].amount`,
                        e.target.value
                      );
                    }}
                    value={formik.values.card_limit[i].amount}
                  />
                  {i > 0 && <MinusCircleOutlined className="ml3 cursor" onClick={() => {
                    let conditions = formik.values.card_limit
                    conditions.splice(i, 1)
                    formik.setFieldValue("card_limit", conditions)
                  }} />}
                </div>
              </>
            ))}
            <Button
              type="default"
              ghost
              className="approve-add-btn mt1"
              onClick={() => {
                formik.setFieldValue(`card_limit`, [
                  ...formik.values.card_limit,
                  {
                    transaction_type: "",
                    amount: "",
                    frequency: "",
                  },
                ]);
              }}
            >
              + Add one more
            </Button>
            <div className="errorMsg">{formik.touched.card_limit && formik.errors.card_limit?.length > 0 && "Card Limit should not be empty"}</div>
          </Panel>
        </Collapse>
        {/* <Collapse accordion className="customCollapse" defaultActiveKey={["4"]}>
          <Panel header={<b>Actions</b>} key="4">
            <Text>
              Select the actions you want to occur when the rule applies.
            </Text>
            <Checkbox>Blocking</Checkbox>
          </Panel>
        </Collapse> */}

        <Button
          key="1"
          htmlType="submit"
          className="formButton mt3 primaryButton"
        >
          Save
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt3"
          onClick={() => {
            handleCancelButton()
            formik.resetForm()
          }}
        >
          Cancel
        </Button>
      </Form>
    </>
  );
};

export { AddCards };

